// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"121":"gallery","548":"calendar"}[chunkId] + "." + {"121":"cd022819","548":"19855730"}[chunkId] + ".js";
};